import React, { Component } from 'react'
import './MobileNavigationContainer.css'
import SocialNetworking from '../socialnetworking/SocialNetworkingContainer'

class MobileNavigationContainer extends Component {
  constructor (props) {
    super(props)

    this.props = props

    this.state = {
      burgerNavigationRef: React.createRef()
    }
  }

  render () {
    return <div id='menuToggle'>

      <input type='checkbox' />

      <span />
      <span />
      <span />

      <ul id='menu'>
        {
          this.props.menuItems.map((item, index) => {
            return <b><a key={index} onClick={() => this.props.goToSection(item)}>
              <li className={item.activeLink ? 'item-active' : 'item'}>{item.displayHeader}</li></a></b>
          })
        }
        <div className='mobile-social-networking-container'>
          <SocialNetworking />
        </div>

      </ul>
    </div>
  }
}

export default MobileNavigationContainer
